<template>
  <div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
    <div :class="'relative  pt-[80px] pb-[80px]  grid items-center p-4 w-full h-full md:h-[100vh] ' + (size ? size : 'max-w-5xl')">
      <div class="relative rounded-xl shadow bg-theme-modalbg">
        <div class=" p-4 text-[14px] rounded-lg">
          <div class="relative">
            <h2 class="text-2xl text-white text-center pr-[40px]">New Location Creation</h2>
            <span class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60"  @click.prevent="callback()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
              </svg>
            </span>
          </div>
          
          <div class="m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg py-2 px-2 pb-4">
            <div class="grid gap-4 m-2 tracking-wider grid-cols-9">
   
              <div :class="'input-wrapper col-span-2 ' + (form.name.error_type)">
                <label class="block text-white text-sm" for="name">Name</label>
                <input @keyup="validateFields(['name'])" v-model="form.name.value" class="appearance-none rounded w-full py-2 px-3 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline" id="name" placeholder="Toronto Cannabis store" type="text">
                <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
              </div>

              <div :class="'input-wrapper col-span-2 ' + (form.slug.error_type)">
                <label class="block text-white text-sm" for="slug">Slug</label>
                <input @keyup="validateFields(['slug'])" v-model="form.slug.value" class="appearance-none rounded w-full py-2 px-3 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline" id="slug" placeholder="Toronto-Cannabis-store" type="text">
                <p class="text-xs text-white py-1">Create a URL slug for your online store.</p>
                <p class="field-error label-text mt-1" v-if="form.slug.error_message" v-text="form.slug.error_message"></p>
              </div>

              <div :class="'input-wrapper col-span-2 ' + (form.licenseId.error_type)">
                <label class="block text-white text-sm" for="license_id">License ID</label>
                <input @keyup="validateFields(['licenseId'])" v-model="form.licenseId.value" class="appearance-none rounded w-full py-2 px-3 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline" id="license_id" placeholder="123456457" type="text">
                <p class="field-error label-text mt-1" v-if="form.licenseId.error_message" v-text="form.licenseId.error_message"></p>
              </div>

              <div :class="'input-wrapper col-span-2 ' + (form.businessBrandProfileId.error_type)">
                  <label class="block text-white text-sm">Brand Profile</label>
                  <SelectSearchBrand
                      v-model.string="form.businessBrandProfileId.value"
                      :selectNone="false"
                      :options="businessProfiles"
                      placeholder="No Profile"
                      class="relative block rounded bg-gray-black w-full border-none text-sm text-white"
                      classString="w-full shadow"
                      @change="validateFields(['businessBrandProfileId'])"
                  />
                  <p class="field-error label-text mt-1" v-if="form.businessBrandProfileId.error_message" v-text="form.businessBrandProfileId.error_message"></p>
              </div>

              <div>
                <div class="flex flex-col" @click.prevent="toggle()">
                  <div class="block text-white text-sm cursor-pointer">Active</div>
                  <label class="flex items-center cursor-pointer mt-2">
                    <input type="checkbox" v-model="form.active.value" class="hidden peer">
                    <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.active.value ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                    <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.active.value ? 'text-theme-green' : 'text-[#F53333]'">{{form.active.value ? 'On' : 'Off'}}</span>
                  </label>
                </div>
              </div>

            </div>
            <div class="full flex">
              <button @click.prevent="addNewLocation()" class="uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-3/5 mt-6 text-lg border-0 rounded-md p-2 block mx-auto">Create</button>
            </div>
          </div>

         
          <!-- <div class="mt-3 mb-1 text-center">
            <button @click.prevent="callback()" class="text-white hover:text-theme-green text-center">CLOSE</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { defineComponent, ref } from "vue";
import LocationsApis from '@/controllers/LocationsApis';
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import SelectSearchBrand from '@/components/form/SelectSearchBrand';
import BrandingProfileApis from '@/controllers/BrandingProfileApis';

export default defineComponent({
  name: "AddNewLocatonModal",
  components: {
    SelectSearchBrand
  },
  
  setup() {
    const businessProfiles = ref([]);
    const form = ref({ 
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required','min:2'],
      }, 
      slug: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:2'],
      }, 
      licenseId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      }, 
      active: {
        value: true,
        error_type: '',
        error_message: '',
        validations: [],
      },
      businessBrandProfileId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
    });
    const snackbar = useSnackbar();
    return {
      businessProfiles,
      form,
      snackbar,
    };
  },
  
  props: {
    callback: {
      type: Function,
      required: true,
    },
  },

  watch:{
    // Slug cannot have whitespaces
    'form.slug.value'(val){
      if(val) {
        val = val.toLowerCase();
        val = val.replaceAll(/\s/g,'').trim();
        this.form.slug.value = val;
      } else {
        this.form.slug.value = '';
      }
    },
  },

  async mounted() {
    this.fetchBusinessProfiles();
  },

  methods: {

    async fetchBusinessProfiles() {
      try {
        const res = await BrandingProfileApis.fetchBusinessBrandingProfile();
        if (res?.status === 200 && Array.isArray(res?.data?.payload)) {
          this.businessProfiles = res.data.payload;
        } else {
          this.businessProfiles = [];
        }
      } catch (error) {
        this.businessProfiles = [];
      }
    },

    toggle(){
      this.form.active.value = !this.form.active.value
    },

    validateFields(fields) {
      this.$nextTick(async () => {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      })
    },
    async validateAllFields(fields){
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    async addNewLocation() {
      let validate = await this.validateAllFields(['name', 'slug', 'licenseId', 'businessBrandProfileId']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let res = await LocationsApis.createLocation({
        name: this.form.name.value.trim(), 
        slug: this.form.slug.value, 
        licenseId: this.form.licenseId.value.trim(), 
        businessBrandProfileId: this.form.businessBrandProfileId.value,
        active: this.form.active.value,
      });
      this.va_spinner(false);

      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })

      if(res.status == 201){
        this.va_setAllLocations();
        this.callback(); // close mdoal
      }
   
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_setAllLocations: 'location/setAllLocations',
    })

  },
});
</script>